var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_Hero_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"video"},[_c('div',{staticClass:"embed-container",domProps:{"innerHTML":_vm._s(_vm.content.field_Hero_video)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bda01c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Hero.vue
// module id = 49
// module chunks = 0